module.exports = __webpack_public_path__ + "img/boongo.7c5d5140.png";